import {animate, AnimationTriggerMetadata, style, transition, trigger} from '@angular/animations';

export const LogoRotate: AnimationTriggerMetadata = trigger('logo', [
  transition('* => before-load', [
    style({ transform: 'scale(0)' }),
    animate('0.3s ease-in', style({ transform: 'scale(1)' }))
  ]),
]);
